<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Image({
              label: 'Zdjęcie',
              modelPath: [this, 'form', 'image'],
              multilingual: true,
              required: true
            }),
            new fields.Attachment({
              label: 'Załącznik',
              modelPath: [this, 'form', 'attachment'],
              multilingual: true,
              required: true
            })
          ]
        }
      ]
    }
  }
}
</script>
